import { createContext,useState,useEffect } from 'react'
import { get, post } from '../utils/axios'
import axios from 'axios'

const Context = createContext({
    profile: {roleId: 0},
    setProfile: () => {},
    guilds: [],
    setGuilds: () => {},
    basket: [],
    setBasket: () => {},
    guildId: '',
    setGuildId: () => {},
    cards: {cards: [],cardNumber: '',balance: ''},
    setCards: () => {},
    cardsTitle: [],
    setCardsTitle: () => {},
    restaurantIndex: 0,
    setRestaurantIndex: () => {},
    showCards: true,
    setShowCards: () => {},
    updateCardData: () => {},
    latitude: '',
    setlatitude: () => {},
    longitude: '',
    setLongitude: () => {},
    address: {},
    setAddress: () => {},
    currentProvinceId: 0,
    setCurrentProvinceId: () => {},
    currentCityId: 0,
    setCurrentCityId: () => {},
    walletPayment: false,
    setWalletPayment: () => {},
    businessParticipator: '',
    setBusinessParticipator: () => {},
    showAllCities: false,
    setShowAllCities: () => {},
})

const ContextProvider = ({ children }) => {
    const [initial,setInitial] = useState(true)
    const [profile,setProfile] = useState({roleId: 0})
    const [guilds,setGuilds] = useState([])
    const [basket,setBasket] = useState([])
    const [guildId,setGuildId] = useState(0)
    const [cards,setCards] = useState({cards: [],cardNumber: '',balance: ''})
    const [latitude,setlatitude] = useState(null)
    const [longitude,setLongitude] = useState(null)
    const [address,setAddress] = useState({})
    const [currentProvinceId,setCurrentProvinceId] = useState(0)
    const [currentCityId,setCurrentCityId] = useState(0)
    const [walletPayment,setWalletPayment] = useState(false)
    const [cardsTitle,setCardsTitle] = useState([])
    const [restaurantIndex,setRestaurantIndex] = useState(-1)
    const [showCards,setShowCards] = useState(true)
    const [businessParticipator,setBusinessParticipator] = useState('')
    const [showAllCities,setShowAllCities] = useState(false)

    const updateCardData = () => {
        if(!profile.roleId || !Object.keys(profile).length)
            return false
        if(profile.roleId != 103){
            get('Card/GetCard').then(({ data }) => {
                if(data.isSuccess){
                    let totalBalance = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(parseInt(data.data[0].cardBalance[0].balance))
                    let segments = data.data[0].cardBalance
                    segments.shift()
                    segments.pop()
                    const cardNo = data.data[0].pan?.replace(/-/g,'')
                    const exp = data.data[0]?.exp
                    const cardsData = {
                        cardNumber: `${cardNo.slice(0,4)} ${cardNo.slice(4,8)} ${cardNo.slice(8,12)} ${cardNo.slice(12,16)}`,
                        exp: `${exp.toString().slice(0,4)}/${exp.toString().slice(4,6)}`,
                        cards: segments,
                        balance: totalBalance
                    }
                    const index = segments.filter(card => cardsTitle.find(c => c.value == card.segmentHash)?.status).findIndex(item => item.segmentHash == 'cc9ef27c19cfb158846572a1dfaa7ef0')
                    setRestaurantIndex(index)
                    setCards(cardsData)
                }
            })
        }else{
            post('Card/GetCardChild').then(({ data }) => {
                if(data.isSuccess){
                    let segments = data.data
                    let totalBalance = 0
                    const newSegments = []
                    segments.map(segment => {
                        totalBalance += segment.reminder
                        if(segment.reminder > 0)
                            newSegments.push(segment)
                    })
                    if(totalBalance == 0)
                        setShowCards(false)
                    const cardsData = {
                        cards: newSegments
                    }
                    const index = segments.filter(card => cardsTitle.find(c => c.value == card.segmentHash)?.status).findIndex(item => item.segmentHash == 'cc9ef27c19cfb158846572a1dfaa7ef0')
                    setRestaurantIndex(index)
                    setCards(cardsData)
                }
            })
        }
    }

    useEffect(() => {
        axios.post('https://petromah.sabinarya.com/service/api/Info/getSegmentData').then(({data}) => {
            if(data.status)
                setCardsTitle(data.result)
            updateCardData()
        })
    },[profile.roleId])

    useEffect(() => {
        if(localStorage.getItem('token') && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined){
            post('General/GetCacheBasket').then(({data}) => {
                if(data.isSuccess)
                    setBasket(JSON.parse(data.data.value))
            }).finally(() => {
                setInitial(false)
            })
            const postedData = {
                key: 'walletpayment'
            }
            post('Config/GetConfigByKey',postedData).then(({ data }) => {
                if(data.isSuccess)
                    setWalletPayment(data.data.value == 1)
            })
            axios.post('https://petromah.sabinarya.com/service/api/Guild/GetAllGuilds',{}).then(({ data }) => {
                if(data.status){
                    const activeGuilds = data.result.filter(guild => guild.isActive)
                    setGuilds(activeGuilds)
                }
            })
        }
    },[])

    useEffect(() => {
        if(!initial){
            const postedData = {
                value: JSON.stringify(basket)
            }
            post('General/SetCacheBasket',postedData)
        }
    },[basket])

    return (
        <Context.Provider value={{profile,setProfile,basket,setBasket,guildId,setGuildId,cards,setCards,cardsTitle,setCardsTitle,restaurantIndex,setRestaurantIndex,showCards,setShowCards,updateCardData,latitude,setlatitude,longitude,setLongitude,address,setAddress,currentProvinceId,setCurrentProvinceId,currentCityId,setCurrentCityId,walletPayment,setWalletPayment,businessParticipator,setBusinessParticipator,showAllCities,setShowAllCities,guilds}}>{children}</Context.Provider>
    )
}

export {
    Context,
    ContextProvider
}